<template>
    <div class="container-fluid">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    setup() {
        
    },
}
</script>

<style scoped>

</style>